import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredCustomers,
  selectCustomerFilterVisible,
  selectCustomerLoading,
  selectfetchCustomerLoading
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteCustomer } from './store/slice';
import { actions as customerActions } from './store/slice';

const { setProduct } = customerActions;

const { CUSTOMERS_ADD_EDIT } = MODAL_TYPES;

const CustomerTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const customerTileRef = useRef(null);
  const filteredCustomers = useSelector(selectFilteredCustomers);
  const isLoading = useSelector(selectCustomerLoading);
  const filterVisible = useSelector(selectCustomerFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);
  const isFetchDataLoading = useSelector(selectfetchCustomerLoading);


  const updateColumnSettings = useCallback(() => {
    if (customerTileRef.current) {
      const width = customerTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredCustomers.map(customer => <Tile customer={customer} />);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''
        }`}
      ref={customerTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredCustomers.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={180} // Adjusted row height for additional fields
        />
      }
    </div>
  );
};

const Tile = ({ customer }) => {

  console.log('Customer itemData', customer);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(setProduct(customer));
    dispatch(showModal(CUSTOMERS_ADD_EDIT, customer));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deleteCustomer(customer.processId));
  };

  return (
    <div key={customer.processId || Math.random()} className="shipment-tile ellipsis-tile">
      <div
        className={`card p-3 m-2 ${customer.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-1 truncate-2lines" title={customer.customerName}>{customer.customerName}</h6>
              <div className="mb-1">
                <span className="text-dark fw-medium">{customer.customerShortName || '--'}</span>
              </div>
              <div className="mb-2">
                <span className="text-dark fw-medium">{customer.label || '--'}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="ms-2">
          <div className="mt-1">
            <span
              className="badge"
              style={{
                backgroundColor: customer.backGroundColor || '#e0e0e0',
                color: customer.textColor || '#000000',
              }}
            >
              {customer.status || 'N/A'}
            </span>
          </div>
          {/* <div className="mt-2 d-flex align-items-center" style={{ lineHeight: '1rem' }}>
            <h5 className="heading me-2">{customer.customerIdExt || '--'}</h5> | <h5 className="ms-2 heading">{customer.id}</h5>
          </div> */}
        </div>

      </div>
    </div>
  );
};

export default CustomerTile;
